export const profileMessages = {
  en: {
    ABSENCE_CREATED: "Absence was successfully created",
    ABSENCE_UPDATED: "Absence was successfully updated",
    CONTACT_INFO_UPDATED: "Contact Info Updated Successfully",
    PASSWORD_UPDATED: "Password Updated Successfully --- account/set-password",
    MY_PASSWORD_UPDATED: "Password Updated Successfully --- account/my-password",
  },
};

export default {
  en: {
    ID: "ID",
    START_DATE: "Start Date",
    START_RTW_DATES: "Start-RTW Dates",
    RETURN_TO_WORK: "Return to Work",
    REASON_FOR_THE_ABSENCE: "Reason for the Absence",
    EMPLOYEE_REF_NO: "Employee Ref No",
    EMPLOYEE_CAN_BE_CONTACTED_ON: "Employee can be contacted on",
    SPELL_COUNT: "{count} spell",
    SPELL_COUNT_plural: "{count} spells",
    COUNT_WORKING_DAY_LOST: "{count} working day lost",
    COUNT_WORKING_DAY_LOST_plural: "{count} working days lost",
    COUNT_WORKING_HOUR_LOST: "{count} working hour lost",
    COUNT_WORKING_HOUR_LOST_plural: "{count} working hours lost",
    ALERTS_TRIGGERED_DURING_THIS_ABSENCE: "Alerts triggered during this Absence",
    CLOSED: "Closed",
    START_DATE_AND_TIME: "Start Date & Time",
    JOB_TITLE: "Job title",
    POSITION_ID: "Position ID",
    POSITION_REF: "Position Ref",
    WEEKLY_CONTRACTED_HOURS: "Weekly Contracted Hours",
    DAYS_PER_YEAR: "Days Per Year",
    EFFECTIVE_FROM_DATE: "Effective From Date",
    EFFECTIVE_END_DATE: "Effective End Date",
    SALARY: "Salary",
    WORKING_DAYS_YEAR: "Working Days / Year",
    DATE_ASSIGNED: "Date assigned",
    ROLE_NAME: "Role Name",
    ASSIGNED_BY: "Assigned By",
    TOTAL_FTE: "Total FTE",
    FTE: "FTE",
    ABSENCES: "Absences",
    ADD_INTERACTION: "Add Interaction",
    ADVISOR: "Advisor",
    INTERACTION_NOTES: "Interaction Notes",
    EDIT_PATTERN: "Edit Pattern",
    NOTIFICATIONS: "Notifications",
    NOTIFICATION_ID: "Notification ID",
    METHOD: "Method",
    RECEIPENTS: "Receipents",
    DATE_SENT: "Date Sent",
    CONSENT_TO_SHARE: "Consent to Share",
    DATE_CAPTURED: "Date Captured",
    ABSENCE_ID: "Absence ID",
    FIT_DATE: "Fit Date",
    RTW_DATE: "RTW Date",
    RTW_DATE_AND_TIME: "RTW Date & Time",
    ABSENCE_REASON_CLASSIFICATION: "Absence Reason Classification",
    CONSENT_STATUS: "Consent Status",
    CONSENT_GIVEN: "Consent Given",
    DATE_REPORTED: "Date Reported",
    DATE_CLOSED: "Date Closed",
    EMPLOYEE_NAME: "Employee Name",
    EMPLOYEMENT_INFO: "Employment Info",
    EMPLOYMENT_START: "Employment Start",
    SERVICE_LENGTH: "Service Length",
    CONTRACTED_HOURS: "Contracted Hours",
    ANNUAL_WORKING_DAYS_AVAILABLE: "Annual Working Days Available",
    PERSONAL_EMAIL_ADDRESS: "Personal Email Address",
    WORK_EMAIL: "Work Email",
    HOME_PHONE: "Home Phone",
    HOME_PHONE_NUMBER: "Home Phone Number",
    MOBILE_PHONE: "Mobile Phone",
    MOBILE_PHONE_NUMBER: "Mobile Phone Number",
    WORK_PHONE: "Work Phone",
    DATE_REGISTERED: "Date Registered",
    PAGE_NUMBER: "Showing",
    PAGE_OF: "of",
    LINKS_AND_ATTACHMENTS: "Links & Attachments",
    MY_ABSENCE_STATISTICS: "My Absence Statistics",
    MY_ABSENCE_STAGE: "My Absence Stage",
    CURRENT_MONITORING_STAGE: "Current Monitoring Stage",
    MONITORING_HISTORY: "Monitoring History",
    MY_EMPLOYEES: "My Employees",
    MY_PERSONAL_DETAILS: "My Personal Details",
    YEARS: "years",
    ACCESS: "Access",
    // Absence Statistics
    ABSENCE: "Absence",
    ABSENCE_MEASURE: "Absence Measure",
    ORGANISATION_AVERAGE: "Organisation Average",
    NUMBER_OF_ABSENCES: "Numbers of Absences",
    NUMBER_OF_DAYS: "Numbers of Days",
    NUMBER_OF_SPECIFIC_AREA: "Numbers in Specified Areas",
    ALERTS_TRIGGERED: "Alerts Triggered",
    REFERRALS_MADE: "Referrals Made",
    RTWS_TO_BE_COMPLETED: "RTWs To Be Completed",
    ABSENCES_RATE_PERC: "Absence Rate %",
    ABSENCE_RATES: "Absence Rates",
    BRADFORD_SCORE: "Bradford Score",
    TOTAL_DAYS_LOST_BY_WEEKDAY: "Total Days Lost (By Weekday)",
    DAYS_LOST_BY_ST_AND_LT_ABSENCE: "Days Lost By ST and LT Absence",
    SHORT_TERM: "Short Term",
    LONG_TERM: "Long Term",
    DAYS_LOST_PER_EMPLOYEE: "Days Lost Per Employee",
    DAYS_LOST_PER_REASON: "Days Lost Per Reason",
    REASON: "Reason",
    DAYS: "Days",
    ACCESS_LEVEL: "Access Level",
    AREA_WITH_ACCESS: "Areas I have Access To",
    // Absence Stage
    ALERT_ID: "Alert ID",
    ALERT_TRIGGERED: "Alert Triggered",
    LEVEL: "Level",
    EFFECTIVE_FROM: "Effective From",
    LATEST_EVENT: "Latest Event",
    LAST_UPDATED_BY: "Last Updated By",
    LAST_MEETING_DATE: "Last Meeting Date",
    NEXT_REVIEW_DATE: "Next Review Date",
    EVENT_DATE: "Event Date",
    ACTIVITY_TYPE: "Activity Type",
    ACTIONED_BY: "Actioned By",
    DETAILS: "Details",
    EFFECTIVE_DATE: "Effective Date",
    FURTHER_SUPPORT_ACTIONS: "Further Support Actions",
    MEETING_DATE: "Meeting Date",
    STATUS: "Status",
    ADD_CONTACT: "Add Contact",
    POSITION: "Position",
    LAST_NAME: "Last Name",
    NOTIFICATION_TYPE: "Notification Type",
    ADDITIONAL_CONTACTS: "Additional Contacts",
    COMPLIANCE: "Compliance",
    TASK_COMPLIANCE: "Task Compliance",
    ADDITIONAL_CONTACTS_FOR: "Additional Contacts for {name}",
    MY_CONTACTS: "My Contacts",
    MY_REQUESTED_NEW_NOTIFICATION_CONTACT: "My Requested: New Notification Contacts",
    MY_REQUESTED_NOTIFICATION_TYPE_CHANGES: "My Requested: Notification Type Changes",
    MY_REQUESTED_REMOVED_NOTIFICATION_CONTACT: "My Requested: Removed Notification Contacts",
    MY_EMPLOYEE_TITLE_TOOLTIP_DESCRIPTION:
      "Listed below are the employees for which you are a FULL notification contact, meaning that you are eligible to access their record. You can also click on the View button to see who else receives notifications for the employee.",
  },
};
